import { useCallback, useMemo } from "react"

import { fuzzySearch } from "shared/lib/fuzzySearch"

import Fuzzy from "@leeoniya/ufuzzy"

interface UseFuzzySearchArgs<T> {
  getSearchableString: (item: T) => string
  options?: Fuzzy.Options
}

export function useFuzzySearch<T>({
  options,
  getSearchableString
}: UseFuzzySearchArgs<T>) {
  const fuzzy = useMemo(() => new Fuzzy(options), [options])

  return useCallback(
    (items: T[] | null | undefined, searchTerm: string | null | undefined) => {
      if (!searchTerm || !items) {
        return items || []
      }

      return fuzzySearch(items, searchTerm, getSearchableString, fuzzy)
    },
    [fuzzy]
  )
}
